import presetService from "@services/presetService.js";
import { mock2Component} from "@helpers/component.helper";
import { responsiveFontSize } from "@helpers/text.helper";
import buttonHelper from "@helpers/button.helper";
import { SECTION, WIDGET, GRID } from "@model/components/componentMeta.model";
import {
  component2Mock,
  findParentComponent,
  getComponentMeta,
} from "@helpers/component.helper";
import toast from "@helpers/toast.helper";
import router from "@router/index";

const default_position = {
  top: "0",
  left: "0",
  height: "0",
  width: "0",
}
const state = {
  presets: {
    section: {},
    grid: {},
    widget: {},
    other: {
      page : {
        custom : {},
        system : {}
      }
    },
  },
  elHoverID: [],
  elActiveID: [],
  elActiveParentID: [],
  elVisible: [],
  scrollToId: undefined,

  cellHoverPosition: default_position,
  cellActivePosition: default_position,
  gridHoverPosition: default_position,
  gridActivePosition: default_position,
  widgetHoverPosition: default_position,
  widgetActivePosition: default_position,

  settingPanelWdgProductCateActiveId: undefined,
  widgetTableActiveHeight: 0,
};

const getters = {
  presetsSection: (state) => {
    return state.presets.section;
  },
  presetsGrid: (state) => {
    return state.presets.grid;
  },
  presetsWidget: (state) => {
    return state.presets.widget;
  },
  presetsOther: (state) => {
    return state.presets.other;
  },
  elHoverID: (state) => {
    return state.elHoverID;
  },
  elActiveID: (state) => {
    return state.elActiveID;
  },
  elActiveParentID: (state) => {
    return state.elActiveParentID;
  },
  activeSection: (state, _, rootState) => {
    if (state.elActiveID.includes("component")) {
      if (state.elActiveID.length <= 2) {
        const compIndex = state.elActiveID.indexOf("component");
        return rootState.design.metadata.screen.pages.assets.components[
          state.elActiveID[compIndex + 1]
        ];
      } else {
        if (state.elActiveID[1].search(WIDGET.prefixKey) == 0) { // widget ex: ['component', 'wdgXXX', 'setting']
          const compIndex = state.elActiveID.indexOf("component");
          return rootState.design.metadata.screen.pages.assets.components[
            state.elActiveID[compIndex + 1]
          ];
        } else {
          return rootState.design.metadata.screen.pages.assets.components[
            state.elActiveID[state.elActiveID.length - 1]
          ];
        }
      }
    } else {
      return {};
    }
  },


  cellHoverPosition: (state) => {
    return state.cellHoverPosition;
  },
  cellActivePosition: (state) => {
    return state.cellActivePosition;
  },
  gridHoverPosition: (state) => {
    return state.gridHoverPosition;
  },
  gridActivePosition: (state) => {
    return state.gridActivePosition;
  },
  widgetHoverPosition: (state) => {
    return state.widgetHoverPosition;
  },
  widgetActivePosition: (state) => {
    return state.widgetActivePosition;
  },
  settingPanelWdgProductCateActiveId: (state) => {
    return state.settingPanelWdgProductCateActiveId;
  },
  widgetTableActiveHeight: (state) => {
    return state.widgetTableActiveHeight;
  },
};
const actions = {
  async loadPreset({ commit }, { type, metaName, pageType, groupType }) {
    const response = await presetService.getPreset({ type, metaName, pageType , groupType, });
    commit("SET_PRESET", { type, metaName, pageType, groupType, data: response });
  },
  setPresetRender({ dispatch, rootState, rootGetters }, { id, metaName }) {
    dispatch('design/blockloading', {}, { root: true })
    let languageUse = rootState.design.site.languageUse
    let metaDataID = rootState.design.metadata.metaDataID
    presetService.getPresetRender({ id, metaName, languageUse, metaDataID}).then((response) => {
      if (response.ids.SECTION_WIDGET_ALBUM) {
        Object.entries(response.components).forEach(([key, item]) => {
          if ((item.type == 'SECTION_WIDGET_ALBUM')) {
            let temp = JSON.stringify(item.style);
            let templateFontsLanguage = rootGetters["design/metadata/templateFontsLanguage"];
            temp = temp.replaceAll('{HEADING3_FONT_SIZE}', templateFontsLanguage.heading3.size);
            temp = temp.replaceAll("{HEADING3_FONT_FAMILY}", templateFontsLanguage.heading3.family);
            temp = temp.replaceAll("{HEADING3_FONT_WEIGHT}", templateFontsLanguage.heading3.isBold);
            temp = temp.replaceAll("{HEADING3_FONT_DECORATION}", templateFontsLanguage.heading3.isItalic);
            temp = temp.replaceAll('{PARAGRAPH1_FONT_SIZE}', templateFontsLanguage.paragraph1.size);
            temp = temp.replaceAll("{PARAGRAPH1_FONT_FAMILY}", templateFontsLanguage.paragraph1.family);
            temp = temp.replaceAll("{PARAGRAPH1_FONT_WEIGHT}", templateFontsLanguage.paragraph1.isBold);
            temp = temp.replaceAll("{PARAGRAPH1_FONT_DECORATION}", templateFontsLanguage.paragraph1.isItalic);
            temp = temp.replaceAll('"true"', 'true');
            temp = temp.replaceAll('"false"', 'false');
            temp = JSON.parse(temp);
            response.components[key].style = temp;
          }
        })
      } 
      const { key, object } = mock2Component(
        rootGetters["design/metadata/components"],
        response
      );
      if (metaName == SECTION.name) {
        //  ---------- [Start] Check Limit Slide Section -----------
        if(object[key].type === 'SLIDE_SECTION') {
          const components = this.state.design.metadata.screen.pages.assets.components;
          const limit = rootState.design.page.limit;
          const slideSections = Object.keys(components)
          .filter(key => key.includes('sec'))
          .reduce((obj, key) => {
            if (components[key].type === 'SLIDE_SECTION') obj[key] = components[key]
            return obj;
          }, {});
          let slideSectionCountInPage = Object.keys(slideSections).length;
          if(limit.slideSection && slideSectionCountInPage >= limit.slideSection) {
            dispatch("design/setModal", {
              name: "modal-alert-limit-slide-section",
              payload: {},
            }, { root: true });
            dispatch('design/unblockloading', {}, { root: true })
            return
          }
        } else {
          const components = this.state.design.metadata.screen.pages.assets.components;
          const limit = rootState.design.page.limit;
          const sections = Object.keys(components)
          .filter(key => key.includes('sec'))
          .reduce((obj, key) => {
            obj[key] = components[key]
            return obj;
          }, {});
          let sectionCountInPage = Object.keys(sections).length;
          if(limit.section && sectionCountInPage >= limit.section) {
            dispatch("design/setModal", {
              name: "modal-alert-limit-section",
              payload: {},
            }, { root: true });
            dispatch('design/unblockloading', {}, { root: true })
            return
          }
        }
        //  ---------- [End] Check Limit Slide Section -----------
        dispatch(
          "designIframe/component/addSection",
          {
            key,
            object,
          },
          { root: true }
        )
        var compID = key;
        if (object[key].type == "SLIDE_SECTION") {
          dispatch("designIframe/frame/setSlideSectionActive", {
              component_id: compID,
              index: 0,
            },
            { root: true }
          );
          dispatch("designIframe/frame/setSectionActive", {}, { root: true });
          dispatch("elActive", {
            elementID: ["component", compID, object[key].componentsID[0]],
          });
        } else {
          dispatch("designIframe/frame/setSectionActive", {
              component_id: compID,
              name: compID,
            },
            { root: true }
          );
          dispatch("designIframe/frame/setSlideSectionActive", {}, { root: true });
          dispatch("elActive", {
            elementID: ["component", compID],
          });
        }
       
        dispatch("designIframe/frame/setCellActive", {}, { root: true });
        dispatch("designIframe/frame/setCellHover", {}, { root: true });
        dispatch("designIframe/frame/setWidgetActive", {}, { root: true });
        dispatch("designIframe/frame/setWidgetHover", {}, { root: true });
        dispatch("designIframe/frame/setFloatFrameActive", {}, { root: true });
        dispatch("designIframe/frame/setFloatFrameHover", {}, { root: true });
        
      } else if (metaName == GRID.name) {
        Object.keys(object).map(key => {
          if(object[key].type == "SECTION_WIDGET_BUTTON") {
            let temp = JSON.stringify(object[key].style);
            let templateButton = rootGetters["design/metadata/templateButton"];
            let appearanceLanguage = rootGetters["design/metadata/appearanceLanguage"];
            temp = temp.replaceAll('{FONT_SIZE}', appearanceLanguage.button.fontSize);
            temp = temp.replaceAll('{FONT_FAMILY}', appearanceLanguage.button.fontFamily);
            temp = temp.replaceAll('{FONT_COLOR}', templateButton.fontColor);
            temp = temp.replaceAll('{FONT_COLOR_HOVER}', templateButton.fontColorHover);
            temp = temp.replaceAll('{BACKGROUND_COLOR}', templateButton.backgroundColor);
            temp = temp.replaceAll('{BACKGROUND_COLOR_ALPHA}', templateButton.backgroundColorAlpha);
            temp = temp.replaceAll('{BACKGROUND_COLOR_HOVER}', templateButton.backgroundColorHover);
            temp = temp.replaceAll('{BACKGROUND_COLOR_HOVER_ALPHA}', templateButton.backgroundColorAlphaHover);
            temp = temp.replaceAll('{BOARDER_COLOR}', templateButton.borderColor);
            temp = temp.replaceAll('{BOARDER_COLOR_ALPHA}', templateButton.borderColorAlpha);
            temp = temp.replaceAll('{BOARDER_COLOR_HOVER}', templateButton.borderColorHover);
            temp = temp.replaceAll('{BOARDER_COLOR_HOVER_ALPHA}', templateButton.borderColorAlphaHover);
            temp = JSON.parse(temp);
            temp.backgroundColorAlpha = parseInt(temp.backgroundColorAlpha);
            temp.backgroundColorAlphaHover = parseInt(temp.backgroundColorAlphaHover);
            temp.borderColorAlpha = parseInt(temp.borderColorAlpha);
            temp.borderColorAlphaHover = parseInt(temp.borderColorAlphaHover);
            object[key].style = temp;
          }
        })
        dispatch(
          "designIframe/component/addGrid",
          {
            key,
            object,
          },
          { root: true }
        );
      } else if (metaName == WIDGET.name) {
        Object.keys(object).map(k => {
          if(object[k].type == "SECTION_WIDGET_BUTTON") {
            let temp = JSON.stringify(object[k].style);
            let templateButton = rootGetters["design/metadata/templateButton"];
            let appearanceLanguage = rootGetters["design/metadata/appearanceLanguage"];
            temp = temp.replaceAll('{SHAPE}', buttonHelper.convertButtonType(templateButton.style));
            temp = temp.replaceAll('{FONT_SIZE}', appearanceLanguage.button.fontSize);
            temp = temp.replaceAll('{FONT_FAMILY}', appearanceLanguage.button.fontFamily);
            temp = temp.replaceAll('{FONT_COLOR}', templateButton.fontColor);
            temp = temp.replaceAll('{FONT_COLOR_HOVER}', templateButton.fontColorHover);
            temp = temp.replaceAll('{BACKGROUND_COLOR}', templateButton.backgroundColor);
            temp = temp.replaceAll('{BACKGROUND_COLOR_ALPHA}', templateButton.backgroundColorAlpha);
            temp = temp.replaceAll('{BACKGROUND_COLOR_HOVER}', templateButton.backgroundColorHover);
            temp = temp.replaceAll('{BACKGROUND_COLOR_HOVER_ALPHA}', templateButton.backgroundColorAlphaHover);
            temp = temp.replaceAll('{BOARDER_COLOR}', templateButton.borderColor);
            temp = temp.replaceAll('{BOARDER_COLOR_ALPHA}', templateButton.borderColorAlpha);
            temp = temp.replaceAll('{BOARDER_COLOR_HOVER}', templateButton.borderColorHover);
            temp = temp.replaceAll('{BOARDER_COLOR_HOVER_ALPHA}', templateButton.borderColorAlphaHover);
            temp = JSON.parse(temp);
            temp.backgroundColorAlpha = parseInt(temp.backgroundColorAlpha);
            temp.backgroundColorAlphaHover = parseInt(temp.backgroundColorAlphaHover);
            temp.borderColorAlpha = parseInt(temp.borderColorAlpha);
            temp.borderColorAlphaHover = parseInt(temp.borderColorAlphaHover);
            object[k].style = temp;
          }else if(object[k].type == "SECTION_WIDGET_COUNTER") {
            let temp = JSON.stringify(object[k]);
            let templateFontsLanguage = rootGetters["design/metadata/templateFontsLanguage"];
            temp = temp.replaceAll('{HEADING1_FONT_SIZE}', templateFontsLanguage.heading1.size);
            temp = temp.replaceAll("{RESPONSIVE_FONTSIZE_HEADING1_FONT_SIZE}", responsiveFontSize(templateFontsLanguage.heading1.size));
            temp = JSON.parse(temp);
            object[k] = temp;
          }else if(object[k].type == "SECTION_WIDGET_ALBUM"){
            let temp = JSON.stringify(object[k]);
            let templateFontsLanguage = rootGetters["design/metadata/templateFontsLanguage"];
            temp = temp.replaceAll('{HEADING3_FONT_SIZE}', templateFontsLanguage.heading3.size);
            temp = temp.replaceAll("{HEADING3_FONT_FAMILY}", templateFontsLanguage.heading3.family);
            temp = temp.replaceAll("{HEADING3_FONT_WEIGHT}", templateFontsLanguage.heading3.isBold);
            temp = temp.replaceAll("{HEADING3_FONT_DECORATION}", templateFontsLanguage.heading3.isItalic);
            temp = temp.replaceAll('{PARAGRAPH1_FONT_SIZE}', templateFontsLanguage.paragraph1.size);
            temp = temp.replaceAll("{PARAGRAPH1_FONT_FAMILY}", templateFontsLanguage.paragraph1.family);
            temp = temp.replaceAll("{PARAGRAPH1_FONT_WEIGHT}", templateFontsLanguage.paragraph1.isBold);
            temp = temp.replaceAll("{PARAGRAPH1_FONT_DECORATION}", templateFontsLanguage.paragraph1.isItalic);
            temp = JSON.parse(temp);
            object[k] = temp;
          }else if(object[k].type == "SECTION_WIDGET_TAB") {
            let temp = JSON.stringify(object[k].style);
            let appearanceLanguage = rootGetters["design/metadata/appearanceLanguage"];
            temp = temp.replaceAll('{FONT_SIZE}', appearanceLanguage.button.fontSize);
            temp = temp.replaceAll('{FONT_FAMILY}', appearanceLanguage.button.fontFamily);
            temp = JSON.parse(temp);
            temp.fontSize = parseInt(temp.fontSize);
            object[k].style = temp;
          }else if(object[k].type == "SECTION_WIDGET_REVIEW") {
            let temp = JSON.stringify(object[k].style);
            let templateButton = rootGetters["design/metadata/templateButton"];
            let appearanceLanguage = rootGetters["design/metadata/appearanceLanguage"];
            temp = temp.replaceAll('{FONT_SIZE}', appearanceLanguage.button.fontSize);
            temp = temp.replaceAll('{FONT_FAMILY}', appearanceLanguage.button.fontFamily);
            temp = temp.replaceAll('{FONT_COLOR}', templateButton.fontColor);
            temp = temp.replaceAll('{FONT_COLOR_HOVER}', templateButton.fontColorHover);
            temp = temp.replaceAll('{BACKGROUND_COLOR}', templateButton.backgroundColor);
            temp = temp.replaceAll('{BACKGROUND_COLOR_ALPHA}', templateButton.backgroundColorAlpha);
            temp = temp.replaceAll('{BACKGROUND_COLOR_HOVER}', templateButton.backgroundColorHover);
            temp = temp.replaceAll('{BACKGROUND_COLOR_HOVER_ALPHA}', templateButton.backgroundColorAlphaHover);
            temp = temp.replaceAll('{BOARDER_COLOR}', templateButton.borderColor);
            temp = temp.replaceAll('{BOARDER_COLOR_ALPHA}', templateButton.borderColorAlpha);
            temp = temp.replaceAll('{BOARDER_COLOR_HOVER}', templateButton.borderColorHover);
            temp = temp.replaceAll('{BOARDER_COLOR_HOVER_ALPHA}', templateButton.borderColorAlphaHover);
            temp = JSON.parse(temp);
            const toInt = (v) => (v === null || v === undefined || v === '' ? v : parseInt(v));
            ['buttonAddReview', 'buttonLoad'].forEach((btn) => {
              if (!temp[btn]) return;
              temp[btn].fontSize = toInt(temp[btn].fontSize);
              temp[btn].backgroundColorAlpha = toInt(temp[btn].backgroundColorAlpha);
              temp[btn].backgroundColorAlphaHover = toInt(temp[btn].backgroundColorAlphaHover);
              temp[btn].borderColorAlpha = toInt(temp[btn].borderColorAlpha);
              temp[btn].borderColorAlphaHover = toInt(temp[btn].borderColorAlphaHover);
            });
            object[k].style = temp;
          }
        });

        dispatch(
          "designIframe/component/addWidget",
          {
            key,
            object,
          },
          { root: true }
        );
      } else if (metaName == 'other') {
        dispatch(
            "designIframe/component/addNewComponent",{
            key,
            object,
            parentID: this.state.design.component.elActiveParentID[1]
          },
          { root: true }
        );

        if(object[key].type == "SLIDE_PAGE") {
          const components = this.state.design.metadata.screen.pages.assets.components;
          const slideSection = components[this.state.design.component.elActiveParentID[1]];
          dispatch(
            "designIframe/frame/setSlideSectionActive", {
              component_id: this.state.design.component.elActiveParentID[1],
              index: slideSection.componentsID.length
            },
            { root: true }
          );
        }
        
      }
      dispatch('design/unblockloading', {}, { root: true })
    });
  },
  // loadPresetRender({ dispatch, rootState, rootGetters }, { id, metaName }) {
  //   dispatch('design/blockloading', {}, { root: true })
  //   let languageUse = rootState.design.site.languageUse
  //   let metaDataID = rootState.design.metadata.metaDataID
  //   presetService.getPresetRender({ id, metaName, languageUse, metaDataID}).then((response) => {
  //     let { object } = mock2Component(
  //       rootGetters["design/metadata/components"],
  //       response
  //     );
  //     let appearance = rootGetters["design/metadata/appearance"];
  //     let appearanceLanguage = rootGetters["design/metadata/appearanceLanguage"];
  //     object  = replaceThemeWebsite(object, appearance, appearanceLanguage);

  //     dispatch('design/unblockloading', {}, { root: true })
  //   });
  // },
  exportComponent({ rootGetters }, { componentID }) {
    const components = rootGetters["design/metadata/components"];
    const obj = component2Mock(components, componentID);
    const saveFile = (obj, filename) => {
      const data = JSON.stringify(obj);
      const blob = new Blob([data], { type: "text/plain" });
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = `${filename}.json`;
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    };
    saveFile(obj, componentID);
  },

  copyToClipboardComponent({ rootGetters }, { componentID }) {
    const components = rootGetters["design/metadata/components"];
    const obj = component2Mock(components, componentID);
    const meta = getComponentMeta(componentID);
    if (meta) {
      navigator.clipboard.writeText(JSON.stringify(obj));
      toast.toastCreate({
        parent: this._vm,
        title: "Success!",
        desc: `copied "${meta.name}" to clipboard`,
        varaint: "success",
      });
    } else {
      toast.toastCreate({
        parent: this._vm,
        title: "Oops!",
        desc: `can not copy "${componentID}" to clipboard`,
        varaint: "danger",
      });
    }
  },
  elVisibleChildren({ commit }, { elementID, visible }) {
    commit("elVisible", { elementID, visible });
  },

  elHover({ commit, dispatch }, { elementID, lv }) {
    commit("elHover", { elementID, lv });
    dispatch(
      "design/postToChildren",
      {
        func: "component/elHoverParent",
        payload: { elementID, lv },
      },
      { root: true }
    );
  },
  elHoverChildren({ commit }, { elementID, lv }) {
    commit("elHover", { elementID, lv });
  },
  moveSection({ commit, dispatch }, { moved }) {
    commit("addLog", {
      log: {
        type: "moved",
        pre: [
          {
            oldIndex: moved.newIndex,
            newIndex: moved.oldIndex,
          },
        ],
        post: [
          {
            oldIndex: moved.oldIndex,
            newIndex: moved.newIndex,
          },
        ],
      },
    });
    dispatch(
      "design/commitDataChange",
      {
        payload: {
          snapshot: [
            {
              oldIndex: moved.oldIndex,
              newIndex: moved.newIndex,
            },
          ],
          type: "moved",
        },
      },
      { root: true }
    );
  },
  elActive({ commit, dispatch }, { elementID, lv = 0 }) {
    commit("elActive", { elementID, lv });

    dispatch(
      "design/postToChildren",
      {
        func: "component/elActiveParent",
        payload: { elementID, lv },
      },
      { root: true }
    );
    commit("SET_NEW_HASH");
  },
  elActiveChildren({ commit }, { elementID, lv }) {
    commit("elActive", { elementID, lv });
    commit("design/SET_MODE", {}, { root: true });
    commit("SET_NEW_HASH");
  },
  setActiveElementfromURL({ dispatch }) {
    let path = router.currentRoute.hash;
   
    if (path.includes('/anchor/')) {
      let index =  path.indexOf('/anchor/');
      path = path.slice(0, index);
    }

    path = path.split("/");
    const active = path.slice(3, path.length);

    dispatch("elActive", { elementID: active, lv: 0 });
    dispatch("scrollToId", { elementID: active[1] });
    
    if (active[1] && active[1].substring(0,3) == 'cll') {
      dispatch("design/postToChildren", {
        func: "component/setComponentActivePosition",
        payload: { component_id: active[1], type: 'CELL', action: 'ACTIVE' },
      },{ root: true }
      );
    }
  },
  scrollToId(
    { state, dispatch, commit },
    { elementID, block = "center", behavior = "auto", count = 0 }
  ) {
    if (elementID) {
      if (count == 0) {
        commit("SET_SCROLL_TO_ID", { elementID });
      }
      let elmnt = this.state.design.iframeWin.document.body.querySelector(
        `#${elementID}`
      );
      if (elementID !== "HEADER" && elementID !== "FOOTER") {
        elmnt = this.state.design.iframeWin.document.body.querySelector(
          `#comp-${elementID}`
        );
      }
      const elVisible = state.elVisible[`comp-${elementID}`];
      if (elmnt && state.scrollToId == elementID) {
        setTimeout(() => {
          elmnt.scrollIntoView({ behavior, block });
        }, 100);

        if (!elVisible && count < 5) {
          setTimeout(() => {
            dispatch("scrollToId", { elementID, count: count + 1 });
          }, 200);
        }
      } else if (count < 5 && state.scrollToId == elementID) {
        setTimeout(() => {
          dispatch("scrollToId", { elementID, count: count + 1 });
        }, 200);
      }
    }
  },
  setNewHashJs({ commit }, { url }) {
    commit("SET_NEW_HASH_JS", url);
  },

  setCellActivePosition({ commit }, { position }) {
    commit("SET_CELL_ACTIVE_POSITION", { position });
  },
  setWidgetActivePosition({ commit }, { position }) {
    commit("SET_WIDGET_ACTIVE_POSITION", { position });
  },
  setSettingPanelWdgProductCateActiveId({ commit, dispatch }, { id }) {
    commit('SET_SETTING_PANEL_WDG_PRODUCT_CATE_ACTIVE_ID',{ id })
    dispatch(
      "design/postToChildren",
      {
        func: "component/setSettingPanelWdgProductCateActiveId",
        payload: { id },
      },
      { root: true }
    );
  },
  getWidgetTableActiveHeight({ dispatch }, { widgetId }) {
    dispatch(
      "design/postToChildren",
      {
        func: "component/getWidgetTableActiveHeight",
        payload: { widgetId },
      },
      { root: true }
    );
  },
  setWidgetTableActiveHeight({ commit }, { height }) {
    commit('SET_WIDGET_TABLE_ACTIVE_HEIGHT', { height })
  },
  setComponentActivePosition({ dispatch }, { component_id, type, action }) {
    dispatch("design/postToChildren", {
      func: "component/setComponentActivePosition",
      payload: { component_id: component_id, type: type, action: action },
    },{ root: true });
  },
};
const mutations = {
  SET_PRESET(state, { type, metaName, pageType, groupType, data }) {
    if(pageType && groupType) {
      state.presets[metaName][type][groupType][pageType] = data;
      state.presets[metaName] = JSON.parse(
        JSON.stringify(state.presets[metaName])
      );
    }else {
      state.presets[metaName][type] = data;
      state.presets[metaName] = JSON.parse(
        JSON.stringify(state.presets[metaName])
      );
    }
  },
  elVisible(state, { elementID, visible }) {
    state.elVisible[elementID] = visible;
  },

  elHover(state, { elementID }) {
    if (Array.isArray(elementID)) {
      state.elHoverID = [...elementID];
    } else {
      state.elHoverID = [elementID];
    }
  },

  elActive(state, { elementID, lv = 0 }) {
    if (Array.isArray(elementID)) {
      const isCorrectPage =
        this.state.design.metadata.screen.pages.assets.components[
          elementID[1]
        ] ||
        elementID[0] == "header" ||
        elementID[0] == "footer" ||
        elementID[0] == "design" ||
        elementID[1] == "design" ||
        elementID[0] == "website_theme";
      if (isCorrectPage) {
        const parent = findParentComponent(
          this.state.design.metadata.screen.pages.assets.components,
          elementID[1]
        );
        state.elActiveParentID = [
          ...state.elActiveID.slice(0, lv),
          ...parent,
          ...elementID,
        ];
        state.elActiveID = [
          ...state.elActiveID.slice(0, lv),
          ...elementID,
        ].filter((i) => !!i);
      } else {
        state.elActiveParentID = [...state.elActiveID.slice(0, lv)];
        state.elActiveID = [...state.elActiveID.slice(0, lv)].filter(
          (i) => !!i
        );
      }
    } else {
      const parent = findParentComponent(
        this.state.design.metadata.screen.pages.assets.components,
        elementID
      );
      state.elActiveParentID = [
        ...state.elActiveID.slice(0, lv),
        ...parent,
        elementID,
      ];
      state.elActiveID = [...state.elActiveID.slice(0, lv), elementID].filter(
        (i) => !!i
      );
    }
  },
  SET_NEW_HASH(state) {
    const arr = location.hash.replace("#/", "").replace("#", "").split("/");
    let metaDataID = arr[0] == "page" ? arr[1] : undefined;
    let anchor = '';
    if (this.state.design.metadata.elementID) {
      anchor = `/anchor/${this.state.design.metadata.elementID}`
    }

    let hash = ''
    if (metaDataID && metaDataID != this.state.design.metadata.metaDataID) {
      hash = `#/page/${this.state.design.metadata.metaDataID}${anchor}`;
    } else {
      hash = `#/page/${
        this.state.design.metadata.metaDataID
      }/${state.elActiveID.filter(item => item).join("/")}${anchor}`;
    }

    hash = hash.replace('//', '/');
    location.hash = hash;
  },
  SET_NEW_HASH_JS(state, url) {
    state
    location.hash = url;
  },
  SET_SCROLL_TO_ID(state, { elementID }) {
    state.scrollToId = elementID;
  },


  SET_CELL_HOVER_POSITION(state, { position }) {
    state.cellHoverPosition = position
  },
  SET_CELL_ACTIVE_POSITION(state, { position }) {
    state.cellActivePosition = position
  },

  SET_GRID_HOVER_POSITION(state, { position }) {
    state.gridHoverPosition = position
  },
  SET_GRID_ACTIVE_POSITION(state, { position }) {
    state.gridActivePosition = position;
  },

  SET_WIDGET_HOVER_POSITION(state, { position }) {
    state.widgetHoverPosition = position
  },
  SET_WIDGET_ACTIVE_POSITION(state, { position }) {
    state.widgetActivePosition = position;
  },
  SET_SETTING_PANEL_WDG_PRODUCT_CATE_ACTIVE_ID(state, { id }) {
    state.settingPanelWdgProductCateActiveId = id;
  },
  SET_WIDGET_TABLE_ACTIVE_HEIGHT(state, { height }) {
    state.widgetTableActiveHeight = height;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
